module.exports = __webpack_public_path__ + "img/app-school.51b4072f.jpg";